import { IconName } from 'components_new/atoms/Icon'

import { useCustomer } from 'redux/hooks/Customer'
import { useTranslation } from 'language/translator'

export const useNavigationItems = (): {
  hidden?: boolean
  iconName: IconName
  label: string
  value: string
}[] => {
  const { t } = useTranslation()
  const customer = useCustomer()

  return [
    {
      iconName: 'Home',
      label: t('global', 'home'),
      value: '/'
    },
    ...(customer?.allow_access.allow_key_metrics
      ? [
          {
            iconName: 'KeyMetrics' as const,
            label: t('key_metrics', 'key_metrics'),
            value: '/key-metrics'
          }
        ]
      : []),
    ...(customer?.allow_access.allow_key_metrics
      ? [
          {
            iconName: 'Tasks' as const,
            label: t('tasks', 'tasks'),
            value: '/tasks'
          }
        ]
      : []),
    {
      iconName: 'Groups',
      label: t('global', 'groups'),
      value: '/groups'
    },
    {
      label: t('global', 'dashboards'),
      iconName: 'Dashboards',
      value: '/dashboards'
    }
  ]
}
